import React from 'react';
import { Undo2 } from 'lucide-react';

/**
 * Compact "Refund" badge for merchant credits (negative-amount transactions
 * that aren't card payments). Refunds flow through the workbench like normal
 * transactions but carry a negative amount, so they net the GL when coded.
 */
export function RefundBadge({ transaction }) {
  if (!transaction?.is_refund) return null;
  return (
    <span
      className="inline-flex items-center gap-0.5 px-1.5 py-0.5 rounded text-[10px] font-semibold bg-amber-100 text-amber-700 border border-amber-200"
      title="Merchant refund — codes as a negative-expense line and nets the GL"
    >
      <Undo2 size={9} />
      <span>Refund</span>
    </span>
  );
}
